import React, { useEffect, useState } from "react";
import { Badge, Spinner, Modal, Table, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import {
  FiArrowRight,
  FiPackage,
  FiTruck,
  FiUser,
  FiInfo,
  FiX,
} from "react-icons/fi";
import logo from "../images/TP-_logo-orizz-claim-color.png";
import "bootstrap/dist/css/bootstrap.min.css";

const WidgetCrossDocking = () => {
  const [datiRaw, setDatiRaw] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showFullscreenModal, setShowFullscreenModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const lista = data?.CROSS_DOCKING?.flat() || [];
        setDatiRaw(lista);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore Cross Docking:", err);
        setLoading(false);
      });
  }, []);

  const testate = datiRaw.filter((item) => item.Is_Totale === "1");

  const handleOpenDettaglio = (ordine) => {
    const articoli = datiRaw.filter(
      (d) =>
        d.Is_Totale === "0" &&
        d.Doc_Cliente === ordine.Doc_Cliente &&
        d.Doc_Fornitore === ordine.Doc_Fornitore,
    );
    setSelectedOrder({ ...ordine, articoli });
    setShowModal(true);
  };

  const renderTooltipSpiegazione = (props) => (
    <Tooltip id="info-crossdocking-tooltip" {...props} style={{ ...props.style, fontSize: '0.85rem' }}>
      Questo widget monitora i flussi di <strong>Cross Docking</strong> attivi. Mostra la merce in arrivo da un fornitore (Provenienza) che viene immediatamente smistata verso il cliente finale (Destinatario) senza stoccaggio intermedio. <strong>Clicca su una riga</strong> per analizzare il dttaglio degli articoli.
    </Tooltip>
  );

  // Renderizza la lista delle card dei flussi, riutilizzabile sia nel widget che nel modale fullscreen
  const renderCardsContent = () => {
    if (loading) {
      return (
        <div className="text-center py-5 w-100">
          <Spinner animation="border" variant="danger" />
        </div>
      );
    }

    if (testate.length === 0) {
      return <div className="text-center py-5 text-muted small w-100">Nessun flusso di Cross Docking attivo</div>;
    }

    return testate.map((item, idx) => (
      <div key={idx} className="col">
        <div className="cd-card" onClick={() => handleOpenDettaglio(item)}>
          <div className="flow-line">
            <div className="node text-start">
              <div className="node-label">
                <FiTruck className="me-1" /> Provenienza
              </div>
              <div className="node-doc text-dark">{item.Doc_Fornitore}</div>
              <div className="node-name text-dark" title={item.Fornitore}>{item.Fornitore}</div>
            </div>

            <div className="arrow-box">
              <Badge
                bg="transparent"
                className="border border-danger text-danger"
                style={{ fontSize: "0.55rem" }}
              >
                {item.Conteggio} RIGHE
              </Badge>
              <FiArrowRight className="arrow-icon" />
            </div>

            <div className="node text-end">
              <div className="node-label">
                <FiUser className="me-1" /> Destinatario
              </div>
              <div className="node-doc text-dark">{item.Doc_Cliente}</div>
              <div className="node-name text-dark" title={item.Cliente}>{item.Cliente}</div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div
      className="shadow-lg card"
      style={{
        borderRadius: "16px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        height: "350px",
      }}
    >
      {/* Header Widget */}
      <div
        className="p-3 border-bottom d-flex justify-content-between align-items-center bg-white"
        style={{ zIndex: 110 }}
      >
        <div className="d-flex align-items-center" onClick={() => setShowFullscreenModal(true)} style={{ cursor: "pointer" }}>
          <span
            style={{
              fontWeight: "800",
              fontSize: "0.75rem",
              color: "#1a1a1a",
              letterSpacing: "1px",
              marginRight: "8px",
            }}
          >
            CROSS DOCKING - OGGI
          </span>
          
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 200, hide: 200 }}
            overlay={renderTooltipSpiegazione}
          >
            <span onClick={(e) => e.stopPropagation()} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
              <FiInfo size={14} color="#adb5bd" />
            </span>
          </OverlayTrigger>
        </div>
        <Badge
          pill
          bg="dark"
          style={{ fontSize: "0.65rem", fontWeight: "700" }}
        >
          {testate.length} FLUSSI
        </Badge>
      </div>

      <style>{`
        .scroll-area-cd { overflow-y: auto; flex-grow: 1; padding: 15px; }
        .scroll-area-cd::-webkit-scrollbar { width: 4px; }
        .scroll-area-cd::-webkit-scrollbar-thumb { background: #ced4da; border-radius: 10px; }
        
        .cd-card { 
            border: 1px solid #e6e6e6; border-radius: 12px; 
            padding: 18px; cursor: pointer; 
            transition: all 0.2s ease-in-out; position: relative;
            background: #fff;
        }
        .cd-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.05);
            border-color: #b81f25;
        }
        .cd-card::before {
            content: ''; position: absolute; left: 0; top: 15%; height: 70%; width: 3px;
            background: #b81f25; border-radius: 0 4px 4px 0;
        }

        .flow-line { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
        .node { flex: 1; min-width: 0; }
        .node-label { font-size: 0.6rem; color: #6c757d; font-weight: 800; text-transform: uppercase; margin-bottom: 4px; }
        .node-doc { font-size: 0.85rem; font-weight: 700; color: #1a1a1a; font-family: 'Monaco', monospace; }
        .node-name { font-size: 0.75rem; color: #495057; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        
        .arrow-box { display: flex; flex-direction: column; align-items: center; color: #b81f25; min-width: 70px; }
        .arrow-icon { animation: slideRight 2s infinite; font-size: 1.1rem; margin-top: 5px; }
        
        @keyframes slideRight {
            0% { transform: translateX(-4px); opacity: 0.4; }
            50% { transform: translateX(4px); opacity: 1; }
            100% { transform: translateX(-4px); opacity: 0.4; }
        }

        .modal-light-custom .modal-content { 
            background: #ffffff; 
            border: none; 
            border-radius: 16px; 
            color: #212529; 
        }
        .modal-light-custom .modal-header { 
            border-bottom: 1px solid #dee2e6; 
            background-color: #f8f9fa;
            border-top-left-radius: 16px;
            border-top-right-radius: 16px;
        }
        .info-strip-light { 
            background: #f1f3f5; 
            border: 1px solid #dee2e6; 
            border-radius: 12px;
        }
        .table-light-custom th {
            color: #6c757d;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
      `}</style>

      {/* Lista standard a colonna singola per il widget compatto */}
      <div className="scroll-area-cd">
        <div className="row row-cols-1 g-3">
          {renderCardsContent()}
        </div>
      </div>

      {/* MODALE TUTTO SCHERMO PER LA VISTA RESPONSIVE DI TUTTI I FLUSSI */}
      <Modal show={showFullscreenModal} onHide={() => setShowFullscreenModal(false)} fullscreen={true} animation={true}>
        <Modal.Body className="p-0 d-flex flex-column" style={{ background: "#f8f9fa" }}>
          <div className="p-3 bg-white border-bottom d-flex justify-content-between align-items-center shadow-sm" style={{ zIndex: 110 }}>
            <div className="d-flex align-items-center">
              <span style={{ fontWeight: "800", fontSize: "0.9rem", color: "#1a1a1a", letterSpacing: "1px", marginRight: "8px" }}>
                CROSS DOCKING
              </span>
              <OverlayTrigger placement="bottom" overlay={renderTooltipSpiegazione}>
                <span style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}><FiInfo size={16} color="#adb5bd" /></span>
              </OverlayTrigger>
            </div>
            <div className="d-flex gap-3 align-items-center">
              <Badge bg="danger" className="px-3 py-2" style={{ fontSize: "0.75rem", fontWeight: "700", backgroundColor: "#b81f25" }}>
                {testate.length} ATTIVI
              </Badge>
              <Button variant="outline-dark" className="d-flex align-items-center gap-1 border-0" onClick={() => setShowFullscreenModal(false)} style={{ borderRadius: "10px", height: "38px" }}>
                <FiX size={16} /> Chiudi
              </Button>
            </div>
          </div>
          
          {/* Griglia multi-colonna distribuita su schermi grandi */}
          <div className="flex-grow-1 p-4" style={{ overflowY: "auto" }}>
            <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4">
              {renderCardsContent()}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* MODALE DETTAGLIO - TEMA CHIARO */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        className="modal-light-custom p-5"
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="fw-bold d-flex align-items-center"
            style={{ fontSize: "1rem", color: "#b81f25" }}
          >
            <FiPackage className="me-2" /> ANALISI FLUSSO LOGISTICO
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="bg-white">
          <div className="info-strip-light p-3 mb-4 d-flex justify-content-between align-items-center">
            <div style={{ flex: 1 }}>
              <small
                className="text-muted d-block"
                style={{ fontSize: "0.65rem", fontWeight: "700" }}
              >
                FORNITORE
              </small>
              <span
                className="fw-bold text-dark"
                style={{ fontSize: "0.9rem" }}
              >
                {selectedOrder?.Fornitore}
              </span>
              <div className="text-muted" style={{ fontSize: "0.75rem" }}>
                Doc: {selectedOrder?.Doc_Fornitore}
              </div>
            </div>
            <div className="px-3" style={{ color: "#b81f25" }}>
              <FiArrowRight size={24} />
            </div>
            <div style={{ flex: 1 }} className="text-end">
              <small
                className="text-muted d-block"
                style={{ fontSize: "0.65rem", fontWeight: "700" }}
              >
                CLIENTE
              </small>
              <span
                className="fw-bold text-dark"
                style={{ fontSize: "0.9rem" }}
              >
                {selectedOrder?.Cliente}
              </span>
              <div className="text-muted" style={{ fontSize: "0.75rem" }}>
                Doc: {selectedOrder?.Doc_Cliente}
              </div>
            </div>
          </div>

          <Table responsive hover className="mb-0 table-light-custom">
            <thead>
              <tr style={{ borderBottom: "2px solid #f1f1f1" }}>
                <th className="pb-3" style={{ fontSize: "0.7rem" }}>
                  Descrizione Articolo
                </th>
                <th className="text-center pb-3" style={{ fontSize: "0.7rem" }}>
                  Quantità
                </th>
              </tr>
            </thead>
            <tbody>
              {selectedOrder?.articoli.map((art, i) => (
                <tr key={i} style={{ borderBottom: "1px solid #f8f9fa" }}>
                  <td className="py-3">
                    <div
                      className="fw-bold text-dark"
                      style={{ fontSize: "0.85rem" }}
                    >
                      {art.articolo}
                    </div>
                    <div className="text-muted" style={{ fontSize: "0.75rem" }}>
                      Cod:{" "}
                      <span className="text-dark fw-medium">
                        {art.precodice || "N/A"}
                      </span>
                    </div>
                  </td>
                  <td className="text-center py-3">
                    <Badge
                      pill
                      style={{
                        backgroundColor: "#b81f25",
                        padding: "6px 14px",
                        fontSize: "0.8rem",
                      }}
                    >
                      {art.Conteggio}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer className="bg-light border-top-0 justify-content-center">
          <img
            src={logo}
            alt="Logo"
            style={{ width: "100px", filter: "grayscale(1)", opacity: 0.6 }}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WidgetCrossDocking;